require('../../style/base.css');
require('../../image/index.css');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@2.2.16@vant/lib/button/style/index.js
// module id = Z/8O
// module chunks = 0